import {
  Button,
  Box,
  createStyles,
  Text,
  Select,
  TextInput,
  Modal,
} from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { useForm } from "@mantine/form";
import { useNavigate } from "react-router-dom";
import { DatePickerInput } from "@mantine/dates";
import { clearBillingNotes, getBillingNotes } from "../../services/note";
import { useDispatch } from "react-redux";
import { useState } from "react";
import swal from "sweetalert";
// import { getdiagnosiscode } from "../../services/servicecode";

const useStyles = createStyles(() => ({
  mainbox: {
    background: " #F5F5F5",
    padding: "13px 19px",
  },
  addbox: {
    padding: "15px 16px",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FCFCFC",
  },

  modal: {
    width: "100%",
    overflow: "auto",
    // height:'1700px',
    borderRadius: "1rem 1rem 1rem 1rem",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
    "& .mantine-Paper-root": {
      overflow: "initial !important",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
    // "& .mantine-Modal-header": {
    //   display: "none",
    // },

    "@media (max-width:400px)": {
      width: "auto",
    },
    "& .mantine-1q36a81": {
      padding: "0",
    },
  },

  widthbox: {
    width: "100%",
  },

  formRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    marginTop: "20px",
    "@media (max-width:1300px)": {
      flexDirection: "column",
      gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },

    flexend: {
      display: "flex",
      justifyContent: "flex-end",
    },
  },
  selectnumber: {
    width: "140px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    width: "min-content",
    // justifyContent:'flex-end'
  },
}));
const bgColor = "#FFFFFF";

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 15px",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",

      backgroundColor: bgColor,
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#FBAA0D"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

function AddBillingDate({
  billingdatemodal,
  setBillilingDateModal,
  setBillilingDate,
  setState,
  state,
  setExistingServices
}) {
  const { classes } = useStyles();

  // console.log("state here", state);

  const handleClose = () => {
    setBillilingDateModal(false);
    setState({ ...state, reviewclaim: false, preferences: false, client: true });
  };

  const handleGo = () => {
    setBillilingDateModal(false);
    setState({ ...state, preferences: true, reviewclaim: false, client: false });
  };

  const [calendarOpen, setCalendarOpen] = useState(false);

  const handleCalendarChange = (value) => {
    setCalendarOpen(false);
  };

  const handleCalendarOpen = () => {
    setCalendarOpen(true);
  };

  const form = useForm({
    initialValues: {
      billingdata: "manualbilling",
      billingschedule: "exactdate",
      startdate: new Date(),
      enddate: new Date(),
    },
  });

  // console.log("form", form);

  const onSave = async (values) => {
    try {

      let missingFields = [];

   const optionalFields = [
      "billingschedule",
    ];

    Object.entries(values)
    .filter(([key, _]) => !optionalFields.includes(key))
    .forEach(([key, value]) => !value && missingFields.push(key));

    if (values.billingdata === "billingprogressnote") {
      Object.entries(values)
        .filter(([key, _]) => !optionalFields.includes(key))
        .forEach(([key, value]) => {
          if (!value) {
            missingFields.push(key);
          }
        });
    } else {

      Object.entries(values)
      .forEach(([key, value]) => !value && missingFields.push(key));
    }
    

    if (missingFields.length > 0) {
      await swal({
        title: "Please fill out the following fields",
        text: missingFields.join(", "),
        icon: "warning",
        dangerMode: true,
      });
      return;
    }

      setBillilingDate(values);

      setExistingServices(false)


      if (values.billingdata === "billingprogressnote") {
        const dateRange = {
          start_date: values.startdate,
          end_date: values.enddate,
        };

        await getBillingNotes(dateRange);
      }

      //  localStorage.setItem("laststep","reviewclaim")
       localStorage.removeItem("finalservices")
       localStorage.setItem("billingservices", JSON.stringify(values));
    } catch (error) {
      console.log("error", error);
    }

    handleGo();

    // navigate('/home/billing')

    // setState((prevState) => ({
    //   ...prevState,
    //   addProvider: false,
    //   addClient: true,
    //   addPayer: false,
    // }));

    // console.log('state here',state);

    //  await backbtn();

    // setState(state => ({
    //   ...state,
    //   client: false,
    //   payer: true,
    //   provider: false,
    //   addProvider: false,
    //   addClient: false,
    //   addPayer: false,
    // }));

    // setState(prevState => ({
    //   ...prevState,
    //   client: false,
    //   payer: true,
    //   provider: false,
    //   addProvider: false,
    //   addClient: false,
    //   addPayer: false,
    // }))

    // console.log('state here after',state);

    // addFacilityType({ name: values?.type });
  };

  const today = new Date();

  return (
    <Modal
      // className={classes.addMedicationModal}
      opened={billingdatemodal}
      className={classes.modal}
      size={700}
      title="Add Billing Data"
      shadow="md"
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      radius={"lg"}
      zIndex={1000}
      bg={"#F5F5F5"}
      styles={{
        title: {
          color: "#000",
          fontSize: "24px",
          fontWeight: "700",
        },
        header: {
          display: calendarOpen ? "none" : "block", // Hide header when calendar is open
        },
      }}
      centered
    >
      {/* opened={state.addPayer}
      size={1000}
      title="Add Payer"
      shadow="md"
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      radius={"lg"}
      zIndex={1000}
      styles={{
        title: {
          color: "#000",
          fontSize: "24px",
          fontWeight: "700",
        },
      }}
      centered
    > */}

      <Box className={classes.mainbox}>
        <Text
          style={{ marginBottom: "16px", marginTop: "32px" }}
          ff={"Inter"}
          fz={16}
          fw={600}
          color="#171717"
        >
          Billing Data
        </Text>
        <Box className={classes.addbox}>
          <form onSubmit={form.onSubmit((values) => onSave(values))}>
            <div className={classes.formRow}>
              <Box className={classes.widthbox}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Select Billing Data
                </Text>

                <CustomSelectBox
                  id="billing-type"
                  withAsterisk
                  data={[
                    {
                      value: "billingprogressnote",
                      label: "Billing Progress Note",
                    },
                    { value: "manualbilling", label: "Manual Billing" },
                  ]}
                  {...form.getInputProps("billingdata")}
                />
              </Box>
            </div>
            {/* {form?.values?.billingdata === "manualbilling" ? (
              <div className={classes.formRow}>
                <Box className={classes.widthbox}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Billing Aggregate
                  </Text>

                  <CustomSelectBox
                    id="billing-type"
                    withAsterisk
                    data={[
                      {
                        value: "daily",
                        label: "Daily",
                      },
                      { value: "weekly", label: "Weekly" },
                      { value: "monthly", label: "Monthly" },
                      { value: "exactdate", label: "Exact Date" },
                    ]}
                    {...form.getInputProps("billingschedule")}
                  />
                </Box>
              </div>
            ) : null} */}

                <div className={classes.formRow}>
                <Box className={classes.widthbox}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Billing Aggregate
                  </Text>

                  <CustomSelectBox
                    id="billing-type"
                    withAsterisk
                    data={[
                      {
                        value: "daily",
                        label: "Daily",
                      },
                      { value: "weekly", label: "Weekly" },
                      { value: "monthly", label: "Monthly" },
                      { value: "exactdate", label: "Exact Date" },
                    ]}
                    {...form.getInputProps("billingschedule")}
                  />
                </Box>
              </div>

            <div className={classes.formRow}>
              <Box>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Service Start Date
                </Text>

                <DatePickerInput
                  id="due-date"
                  // label="Due Date"
                  position="bottom"
                  onClick={handleCalendarOpen}
                  onChange={handleCalendarChange}
                  size="md"
                  placeholder="mm/dd/yyyy"
                  maxDate={today}
                  rightSection={
                    <img
                      style={{ width: "20px" }}
                      src={"/assets/images/billingcalendar.png"}
                      alt="Icon"
                    />
                  }
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  {...form.getInputProps("startdate")}
                />
              </Box>

              <Box>
                <Text
                  {...form.getInputProps("type")}
                  ff={"Inter"}
                  fz={14}
                  fw={500}
                  color="#344054"
                >
                  Service End Date
                </Text>

                <DatePickerInput
                  id="due-date"
                  // label="Due Date"
                  position="bottom"
                  size="md"
                  placeholder="mm/dd/yyyy"
                  maxDate={today}
                  rightSection={
                    <img
                      style={{ width: "20px" }}
                      src={"/assets/images/billingcalendar.png"}
                      alt="Icon"
                    />
                  }
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  {...form.getInputProps("enddate")}
                />
              </Box>
            </div>
            <Box
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
                marginTop: "40px",
              }}
            >
              <Button
                onClick={handleClose}
                variant="default"
                c="#000"
                radius="md"
                size="md"
                bg="#F9FAFB"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="filled"
                c="#000"
                radius="md"
                size="md"
                color="yellow"
              >
                Submit
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </Modal>
  );
}

export default AddBillingDate;
